import React, { useEffect, useState } from 'react';
import { Button, Card, CardContent, CircularProgress, Grid, IconButton, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import TodayIcon from '@mui/icons-material/Today';
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
import Groups2Icon from '@mui/icons-material/Groups2';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import DescriptionIcon from '@mui/icons-material/Description';

import QuickreplyIcon from '@mui/icons-material/Quickreply';
import ConstructionIcon from '@mui/icons-material/Construction';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { getopcinesMenu } from '../services/apis';
import { SubHeader } from '../utils/componentes-utiles/SubHeader';


//mapa de iconos
let tamIco = 60;
const iconMapping = {
    TodayIcon: <TodayIcon sx={{ fontSize: tamIco }} />,
    FolderSpecialIcon: <FolderSpecialIcon sx={{ fontSize: tamIco }} />,
    Groups2Icon: <Groups2Icon sx={{ fontSize: tamIco }} />,
    AdminPanelSettingsIcon: <AdminPanelSettingsIcon sx={{ fontSize: tamIco }} />,
    QuickreplyIcon: <QuickreplyIcon sx={{ fontSize: tamIco }} />,
    ConstructionIcon: <ConstructionIcon sx={{ fontSize: tamIco }} />,
    AccessAlarmIcon: <AccessAlarmIcon sx={{ fontSize: tamIco }} />,
    ShoppingCartIcon: <ShoppingCartIcon sx={{ fontSize: tamIco }} />,
    GroupWorkIcon: <GroupWorkIcon sx={{ fontSize: tamIco }} />,
    DescriptionIcon: <DescriptionIcon sx={{ fontSize: tamIco }} />

};

export const MainMenu = () => {
    // Global
    const navigate = useNavigate();

    // Estados auxiliares
    const [loaded, setLoaded] = useState(false);

    // Estados útiles
    const [opciones, setOpciones] = useState([]);

    // Cargar opciones menú principal
    const cargarOpciones = async () => {
        try {
            const response = await getopcinesMenu();
            setOpciones(response.data)
            setLoaded(true);
        } catch (error) {
            console.error("Error al cargar opciones del menu:", error);
            setOpciones([]);
            setLoaded(true);
        }
    };

    const esEnlace = (texto) => {
        if (typeof texto !== 'string' || !texto.trim()) {
            return false;
        }

        // Patrones para detectar enlaces
        const patronesEnlace = [
            /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i, // http://, https://, ftp://
            /^www\.[^\s/$.?#].[^\s]*$/i,             // www.dominio.com
            /^[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,}(:[0-9]{1,5})?(\/.*)?$/i, // dominio.com
            /^[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,}(:[0-9]{1,5})?(\/.*)?\?[^\s]+$/i, // dominio.com?param=valor
            /^[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,}(:[0-9]{1,5})?(\/.*)?#[^\s]+$/i, // dominio.com#seccion
        ];

        return patronesEnlace.some(patron => patron.test(texto.trim()));
    };

    useEffect(() => {
        cargarOpciones();
    }, []);

    return (
        <div className='fade-in-2' style={{ minHeight: '70vh' }}>
            <SubHeader titulo={'Menu principal'} />
            {!loaded && (<CircularProgress />)}
            {loaded && (
                <Grid size={{ xs: 12 }} container gap={4} justifyContent="center">
                    {opciones
                        .filter((opcion) => opcion.tipo === 4)
                        .map((opcion) => (
                            <Grid container size={{ xs: 11, sm: 11, md: 5.8, lg: 3.5, xl: 3 }} key={opcion.id}>
                                {iconMapping[opcion.icon]}
                            </Grid>
                        ))}
                    {opciones
                        .filter((opcion) => opcion.tipo === 0)
                        .map((opcion) => (
                            <Grid
                                container
                                direction="row"
                                justifyContent="space-between"
                                alignItems="center"
                                size={{ xs: 11, sm: 11, md: 5.8, lg: 3.5, xl: 3 }}
                                key={opcion.id}
                                spacing={2}
                                className="menu-card"
                                onClick={() => { esEnlace(opcion.url) ? window.open(opcion.url, '_blank') : navigate(opcion.url) }}
                            >
                                <Grid item size={{ xs: 12, sm: 3, md: 3, lg: 3 }}>
                                    <IconButton size={'large'} color="primary">
                                        {iconMapping[opcion.icon]}
                                    </IconButton>
                                </Grid>

                                <Grid
                                    container
                                    direction="column"
                                    justifyContent="end"
                                    alignItems={{ xs: "start", sm: "end" }}
                                    size={{ xs: 12, sm: 9, md: 9, lg: 9 }}
                                >
                                    <Typography variant="h5">
                                        {opcion.nombre.toUpperCase()}
                                    </Typography>

                                    <Typography variant="caption" sx={{ color: 'gray' }}>
                                        {opcion.descripcion}
                                    </Typography>
                                </Grid>
                            </Grid>
                        ))}
                    {opciones
                        .filter((opcion) => opcion.tipo === 2)
                        .map((opcion) => (
                            <Grid container size={{ xs: 11, sm: 11, md: 5.8, lg: 3.5, xl: 3 }} key={opcion.id}>
                                {/* <TotemFichajeQr id={opcion.url}></TotemFichajeQr> */}
                            </Grid>
                        ))}
                    {opciones
                        .filter((opcion) => opcion.tipo === 3)
                        .map((opcion) => (
                            <Grid container size={{ xs: 11, sm: 11, md: 5.8, lg: 3.5, xl: 3 }} key={opcion.id}>
                                {/* <TotemFichajeNFC id={opcion.url}></TotemFichajeNFC> */}
                            </Grid>
                        ))}


                    {opciones
                        .filter((opcion) => opcion.tipo === 5)
                        .map((opcion) => (
                            <Grid container size={{ xs: 11, sm: 11, md: 5.8, lg: 3.5, xl: 3 }} key={opcion.id} sx={{ mt: 4 }}>
                                {iconMapping[opcion.icon]}
                            </Grid>
                        ))}
                </Grid>
            )}
        </div>
    );
};
